import { render, staticRenderFns } from "./UpcomingSurgeries.vue?vue&type=template&id=60cf8ec8&scoped=true&"
import script from "./UpcomingSurgeries.vue?vue&type=script&lang=js&"
export * from "./UpcomingSurgeries.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingSurgeries.vue?vue&type=style&index=0&id=60cf8ec8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf8ec8",
  null
  
)

export default component.exports